import { call, put, takeEvery } from "redux-saga/effects";

// Login Redux States
import { USER_CREATE, USER_LIST, USER_FILTER, USER_UPDATE } from "store/users/actionTypes";
import {
  userListSuccess,
  userCreateSuccess,
  userUpdateSuccess,
  userRequestFailed,
} from "store/users/actions";

import { postUserCreate, getUserList, getUserFilter, patchUserUpdate } from "connection/backend";

function* userCreateSaga({ payload: user }) {
  console.log("Creando nuevo usuario...");
  try {
    const response = yield call(postUserCreate, user);
    if (response.status === 201) {
      yield put(userCreateSuccess(response.data));
    } else {
      yield put(userRequestFailed(response.data));
    }
  } catch (error) {
    yield put(userRequestFailed(error.response.data));
  }
}

function* userListSaga() {
  console.log("Trayendo lista de usuarios...");
  try {
    const response = yield call(getUserList);
    if (response.status === 200) {
      yield put(userListSuccess(response.data));
    } else {
      yield put(userRequestFailed(response.data));
    }
  } catch (error) {
    yield put(userRequestFailed(error.response.data));
  }
}

function* userUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos del usuario...");
  try {
    const response = yield call(patchUserUpdate,{ id }, data);
    if (response.status === 201) {
      yield put(userUpdateSuccess(response.data));
    } else {
      yield put(userRequestFailed(response.data));
    }
  } catch (error) {
    yield put(userUpdateSuccess(error.response.data));
  }
}

function* userFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getUserFilter, { changeUrl });
    if (response.status === 200) {
      yield put(userListSuccess(response.data));
    } else {
      yield put(userRequestFailed(response.data));
    }
  } catch (error) {
    yield put(userRequestFailed(error.response.data));
  }
}

export default function* userSaga() {
  yield takeEvery(USER_CREATE, userCreateSaga);
  yield takeEvery(USER_LIST, userListSaga);
  yield takeEvery(USER_UPDATE, userUpdateSaga);
  yield takeEvery(USER_FILTER, userFilterSaga);
}
